import { render, staticRenderFns } from "./PromotionGraph.vue?vue&type=template&id=9fc12c20&scoped=true"
import script from "./PromotionGraph.vue?vue&type=script&lang=js"
export * from "./PromotionGraph.vue?vue&type=script&lang=js"
import style0 from "./PromotionGraph.vue?vue&type=style&index=0&id=9fc12c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc12c20",
  null
  
)

export default component.exports